import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Avatar from '@atlaskit/avatar';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import { AvatarLite } from '@atlassian/jira-business-avatar-lite/src/index.tsx';
import type { UserGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/UserGroupHeader.graphql';
import { ASSIGNEE_TYPE, REPORTER_TYPE, USER_CF_TYPE } from '@atlassian/jira-platform-field-config';
import messages from './messages.tsx';

export type Props = {
	userGroupHeader: UserGroupHeader$key | null;
	fieldType: string;
};

export const UserGroupHeader = ({ userGroupHeader, fieldType }: Props) => {
	const data = useFragment<UserGroupHeader$key>(
		graphql`
			fragment UserGroupHeader on JiraJqlUserFieldValue {
				displayName
				user {
					picture
				}
			}
		`,
		userGroupHeader,
	);

	const { formatMessage } = useIntl();

	let noValueText: string | null;
	switch (fieldType) {
		case ASSIGNEE_TYPE:
			noValueText = formatMessage(messages.unassignedDisplayName);
			break;
		case USER_CF_TYPE:
			noValueText = formatMessage(messages.noUserDisplayName);
			break;
		case REPORTER_TYPE:
			noValueText = formatMessage(messages.anonymousDisplayName);
			break;
		default:
			noValueText = null;
	}
	const displayName = data?.displayName ?? noValueText;

	return (
		<>
			{data ? (
				<AvatarLite avatarUrl={data.user?.picture} />
			) : (
				<Avatar appearance="circle" src="" size="small" />
			)}
			<Text>{displayName}</Text>
		</>
	);
};
